// extracted by mini-css-extract-plugin
module.exports = {"button":"WasherProgram_button__2gnSX","addButton":"WasherProgram_addButton__3BR9d"};